import { useTranslation } from "react-i18next";
import signIn from "./signIn.jpg";
import { useState } from "react";
import SignInForm from "./signInForm";
import SignUpForm from "./signUpForm";
import ForgotPass from "./forgotPass";

const SignIn = () => {
  const { t } = useTranslation();
  const [step, setStep] = useState("signIn");

  return (
    <main className="relative min-h-[80vh] py-4 overflow-hidden grid place-content-center">
      <div className="absolute top-0 left-0 w-full h-full">
        <img src={signIn} alt="logistics" className="object-cover size-full" />
        <div className="absolute inset-0 bg-black opacity-50"></div>
      </div>

      <div className="relative md:min-w-[500px] max-w-[500px]  m-auto z-10 text-white p-4 glassy-bg overflow-hidden">
        <div className="flex items-center justify-between gap-4 mb-4">
          <button
            style={{ opacity: step === "signIn" ? 1 : 0.5 }}
            onClick={() => setStep("signIn")}
          >
            {t("signIn")}
          </button>
          <button
            style={{ opacity: step === "signUp" ? 1 : 0.5 }}
            onClick={() => setStep("signUp")}
          >
            {t("signUp")}
          </button>
        </div>
        <div>
          {step === "signIn" && <SignInForm setStep={setStep} />}
          {step === "forgotPass" && <ForgotPass />}
          {step === "signUp" && <SignUpForm />}
        </div>
      </div>
    </main>
  );
};

export default SignIn;
